import type { DefaultTimePeriodKeys } from '@frontend/analytics-shared';
import { i18next } from '@frontend/i18n';
import { BreadcrumbPathProps } from '@frontend/design-system';

export const URLs = {
  PHONE_ANALYTICS_FEEDBACK:
    'https://feedback.getweave.com/forums/938685-weave-portal/suggestions/45636907-call-analytics',
  PHONE_ANALYTICS_HELP: 'https://www.weavehelp.com/weavehelp/article/using-phone-analytics',
  PHONE_ANALYTICS_VIDEO_ID: 'fq3b1i62az',
} as const;

export const PHONE_ANALYTICS_LARGE_DOWNLOADS_KEY = 'phone-analytics';

export const defaultBarChartAppearance = {
  collectiveTooltip: true,
  margin: {
    left: 20,
  },
  showGridLines: true,
  showXAxis: true,
  showYAxis: true,
};

export const defaultTimePeriod: DefaultTimePeriodKeys = 'lastMonth';
export const DEFAULT_ACTIVE_TAB_VIEW = 'charts-view';

export const breadcrumbsBase: BreadcrumbPathProps[] = [
  {
    label: i18next.t('Analytics', { ns: 'analytics-phone' }),
    to: '/analytics/dashboard',
  },
  {
    label: i18next.t('Phone Analytics', { ns: 'analytics-phone' }),
    to: '/analytics/phone/main',
  },
];
